
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetogoainnovacrystacabservicebooking() {



    const cardData =
    {
        keyword: 'Pune to Goa Innova Crysta Cab Services Booking',
        heading: 'Meghana Cab : Pune to Goa Innova Crysta Cab Services Booking',
        headingDescription: 'Meghana Cab offers Pune to Goa Innova Crysta Cab Services Booking, ideal for travelers, families, and groups seeking a luxurious and hassle-free coastal journey. Our premium Innova Crysta vehicles come with plush seating, spacious interiors, ample luggage capacity, and advanced safety features—perfect for a long haul to Goa. Whether you’re traveling to the beach, preparing for a destination wedding, or conducting business, enjoy a serene ride through scenic Western Ghats highways. Benefit from door-to-door pickup from anywhere in Pune, experienced chauffeurs who know the route inside out, transparent fixed fares, GPS tracking, and flexible booking options (one-way, round-trip, or customized itineraries). With Megana Cab’s dependable 24/7 customer support and easy online booking, your Pune to Goa Innova Crysta Cab journey promises comfort, elegance, and unparalleled convenience.',


        top: 'Top Places to Visit in Goa with Meghana Cab',

"topPlaces": [
  {
    "title": "Baga Beach",
    "description": "Located in North Goa, Baga Beach is one of the most vibrant and popular beaches in the state, known for its buzzing nightlife, water sports, and lively shacks. Visitors can enjoy activities such as parasailing, jet skiing, banana boat rides, and dolphin cruises by day, and unwind at clubs like Tito’s and Mambo’s by night. The beach is lined with restaurants and shacks serving seafood and local Goan delicacies. Baga’s energetic atmosphere makes it the perfect destination for party lovers and adventure seekers."
  },
  {
    "title": "Basilica of Bom Jesus",
    "description": "A UNESCO World Heritage Site, the Basilica of Bom Jesus in Old Goa is a revered 16th-century church that houses the mortal remains of St. Francis Xavier. Built in baroque architectural style, the basilica is famous for its intricate carvings, gilded altars, and marble mosaic flooring inlaid with precious stones. The embalmed body of the saint is displayed every ten years during public exposition. This sacred site attracts pilgrims and architecture enthusiasts from around the globe."
  },
  {
    "title": "Dudhsagar Waterfalls",
    "description": "Situated on the Goa-Karnataka border, Dudhsagar Waterfalls is a four-tiered waterfall cascading from a height of over 300 meters. Surrounded by the lush Bhagwan Mahaveer Wildlife Sanctuary, the falls are most magnificent during the monsoon when the water gushes down with milky intensity—earning the name 'Dudhsagar' or ‘Sea of Milk’. Jeep safaris through forest trails and treks to the base of the falls offer thrilling ways to explore this natural marvel. The nearby railway bridge often features in travel photos and Bollywood films like 'Chennai Express.'"
  },
  {
    "title": "Fort Aguada",
    "description": "Built in 1612 by the Portuguese to guard against Dutch and Maratha invasions, Fort Aguada is perched on a hill overlooking the Arabian Sea in Sinquerim. It once housed a freshwater spring (which gave the fort its name) and Asia’s oldest lighthouse, which still stands tall. The fort offers panoramic views of the coastline and remains a favorite sunset spot for tourists. Its well-preserved bastions and historical significance make it one of Goa’s top heritage attractions."
  },
  {
    "title": "Anjuna Beach & Flea Market",
    "description": "Anjuna Beach is synonymous with Goa’s bohemian spirit and 1960s hippie legacy. It’s known for its rocky shoreline, trance parties, and weekly flea market held every Wednesday. The market is a vibrant blend of local artisans, Tibetan traders, and international sellers offering jewelry, clothes, art, spices, and souvenirs. The beach is perfect for paragliding, relaxing yoga sessions, and catching mesmerizing sunsets. It continues to attract alternative travelers, backpackers, and free spirits."
  },
  {
    "title": "Palolem Beach",
    "description": "Located in South Goa, Palolem Beach is a crescent-shaped beach lined with swaying palms, colorful shacks, and gentle waves. It’s ideal for families, solo travelers, and couples looking for peace and natural beauty. The beach is famous for its 'silent disco' parties where music is played through wireless headphones. Activities like kayaking, dolphin spotting, and yoga retreats are popular here. With its calm waters and artistic vibe, Palolem is one of Goa’s most picturesque and laid-back beaches."
  },
  {
    "title": "Chapora Fort",
    "description": "Famed for its role in Bollywood’s 'Dil Chahta Hai', Chapora Fort offers panoramic views of Vagator Beach and the Chapora River. Originally built by the Portuguese in 1717, the fort now stands in ruins, but its scenic vantage point and open skies attract history lovers and sunset chasers. The short trek to the top is rewarded with stunning photo opportunities and a tranquil, wind-swept environment."
  },
  {
    "title": "Fontainhas (Latin Quarter of Panaji)",
    "description": "Fontainhas in Panaji is Goa’s Latin Quarter, known for its colorful Portuguese-style houses, narrow winding lanes, and heritage charm. Walking through this UNESCO-recognized heritage zone is like stepping back in time, with its pastel-colored villas, red-tiled roofs, wrought-iron balconies, and street art. Visitors can explore art galleries, bakeries, cafes, and the iconic St. Sebastian Chapel. It’s a cultural gem that reflects Goa’s Indo-Portuguese fusion like no other neighborhood."
  },
  {
    "title": "Calangute Beach",
    "description": "Often referred to as the ‘Queen of Beaches’, Calangute is Goa’s largest and most commercial beach. It’s popular for its wide stretch of golden sand, energetic crowd, and extensive water sports options including windsurfing, parasailing, and speedboat rides. Surrounded by resorts, eateries, and local markets, Calangute is a tourist hotspot year-round. Whether for sunbathing, shopping, or nightlife, it offers a complete beach holiday experience."
  },
  {
    "title": "Spice Plantations of Ponda",
    "description": "Located inland near Ponda, Goa’s spice plantations offer a unique and educational experience of eco-tourism. Guided tours take visitors through lush plantations of cardamom, nutmeg, black pepper, cloves, vanilla, and betel nut, explaining traditional cultivation techniques. Many estates also include elephant rides, Goan-style buffet lunches, and Ayurvedic garden walks. It’s a refreshing green escape into the aromatic heart of Goa’s agricultural heritage."
  }
],

"services": [
  {
    "name": "Pune to Goa Innova Crysta Cab Booking",
    "description": "Book your Pune to Goa Innova Crysta cab for a scenic, smooth, and luxurious road trip. Our cabs are perfect for travelers who want a comfortable long-distance ride with professional chauffeurs, flexible stops, and ample space for passengers and luggage."
  },
  {
    "name": "One Way Innova Crysta Pune to Goa",
    "description": "Enjoy a stress-free one-way journey from Pune to Goa in a premium Innova Crysta. This service is ideal for solo travelers, families, or groups heading to Goa for a beach vacation, providing door-to-door pickup and drop in a spacious, air-conditioned SUV."
  },
  {
    "name": "Round Trip Innova Crysta Pune Goa",
    "description": "Plan your Pune-Goa-Pune round trip with our reliable Innova Crysta cab service. Get complete travel flexibility, experienced drivers, and a comfortable ride ideal for both leisure and business travel, whether it's a weekend escape or a longer coastal holiday."
  },
  {
    "name": "AC Innova Crysta Taxi Pune Goa",
    "description": "Beat the coastal heat with our fully air-conditioned Innova Crysta taxi from Pune to Goa. With plush seats, powerful AC, and smooth suspension, you’re guaranteed a relaxed and pleasant experience over the long highway drive."
  },
  {
    "name": "Chauffeur Driven Innova Crysta Pune to Goa",
    "description": "Travel in style and ease with our chauffeur-driven Innova Crysta from Pune to Goa. Our trained drivers ensure safety, punctuality, and comfort, allowing you to sit back, relax, or enjoy the scenic journey without any hassle."
  },
  {
    "name": "Private Innova Crysta Taxi Pune to Goa",
    "description": "Get the exclusivity and privacy you need with a private Innova Crysta taxi from Pune to Goa. Perfect for families, couples, or VIPs, this service provides a dedicated vehicle with no shared passengers, offering comfort and peace of mind."
  },
  {
    "name": "Online Booking Innova Crysta Cab Pune Goa",
    "description": "Book your Pune to Goa Innova Crysta cab online in just a few clicks. Our digital platform offers real-time availability, instant booking confirmations, secure payments, and the flexibility to choose your pickup time and location."
  },
  {
    "name": "Family Innova Crysta Trip Pune Goa",
    "description": "Make your Pune to Goa family trip extra comfortable with our spacious 6- or 7-seater Innova Crysta. With plenty of legroom, luggage space, and AC comfort, it’s perfect for vacations with kids, seniors, and large travel bags."
  },
  {
    "name": "Budget Innova Crysta Cab Pune Goa",
    "description": "Looking for a pocket-friendly yet premium ride to Goa? Our budget Innova Crysta cab service from Pune offers the perfect balance of comfort and affordability, ideal for group trips, weekend getaways, and long drives without compromising on quality."
  }
],
"tableData": [
  ["Pune to Goa Innova Crysta Cab Booking", "One Way Innova Crysta Pune to Goa"],
  ["Round Trip Innova Crysta Pune Goa", "AC Innova Crysta Taxi Pune Goa"],
  ["Chauffeur Driven Innova Crysta Pune to Goa", "Private Innova Crysta Taxi Pune to Goa"],
  ["Online Booking Innova Crysta Cab Pune Goa", "Family Innova Crysta Trip Pune Goa"],
  ["Budget Innova Crysta Cab Pune Goa", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Premium Pune to Goa Innova Crysta Cab Services",
        "WhyChoosedescription": "Enjoy a scenic and comfortable journey from Pune to Goa in a spacious, air-conditioned Innova Crysta. Perfect for family vacations, group travel, or beach getaways, our cab service offers luxury, safety, and reliability over the 450+ km route."
    },
    {
        "WhyChooseheading": "Spacious and Luxurious Interiors for Long Travel",
        "WhyChoosedescription": "The Innova Crysta is ideal for long-distance travel with its ample legroom, comfortable reclining seats, and superior suspension. Accommodating up to 6–7 passengers with plenty of luggage space, it ensures a relaxing journey even on hilly or coastal roads."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Route and Terrain Expertise",
        "WhyChoosedescription": "Our trained drivers are well-versed with Pune–Goa routes, including scenic highways and safe hill paths. Whether you choose the NH66 coastal drive or the NH48 expressway, our drivers ensure a smooth, safe, and timely ride."
    },
    {
        "WhyChooseheading": "Clean, Well-Maintained, and Sanitized Vehicles",
        "WhyChoosedescription": "All our Innova Crysta cabs are regularly cleaned, disinfected, and mechanically inspected before every trip. Travel worry-free in a hygienic and well-maintained vehicle that’s ready for a long journey."
    },
    {
        "WhyChooseheading": "Flexible Booking and Itinerary Customization",
        "WhyChoosedescription": "Choose one-way or round-trip bookings, single-day or multi-day packages, and customize your pickup/drop-off points and sightseeing stops en route. We tailor the travel plan to your convenience."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "Our Pune to Goa cab fares are fully transparent with no hidden fees. The fare includes fuel, tolls, driver allowance, and taxes—delivering top-tier service at fair and honest rates."
    },
    {
        "WhyChooseheading": "Perfect for Beach Vacations, Events, and Group Tours",
        "WhyChoosedescription": "Whether you’re heading to Goa for a wedding, retreat, or fun with friends, the Innova Crysta ensures you travel in comfort and arrive refreshed. Ideal for groups and families seeking a luxurious travel experience."
    },
    {
        "WhyChooseheading": "24/7 Booking and Support Service",
        "WhyChoosedescription": "Book your cab online or through our customer support at any time, day or night. We offer real-time booking assistance, travel updates, and help with last-minute itinerary changes for a seamless trip."
    }
]























    }

const faqData = [
    {
        question: "How can I book an Innova Crysta cab from Pune to Goa?",
        answer: "You can book by calling Meghana Cab at +91 9075462128 or visit our website for a quick and convenient online booking."
    },
    {
        question: "What is the distance and travel time from Pune to Goa?",
        answer: "The distance is around 450 km, and the travel time typically ranges between 8 to 10 hours depending on the route and traffic."
    },
    {
        question: "Is Innova Crysta a good option for the Pune to Goa route?",
        answer: "Yes, Innova Crysta is perfect for long journeys like Pune to Goa, offering comfort, space, and smooth handling."
    },
    {
        question: "Can I book a one-way or round trip to Goa?",
        answer: "Yes, Meghana Cab offers both one-way and round-trip options for Pune to Goa travel."
    },
    {
        question: "What is included in the cab fare?",
        answer: "The fare includes driver charges, fuel, and tolls. Additional charges may apply for waiting time or parking if required."
    },
    {
        question: "Is the Innova Crysta available for family or group travel to Goa?",
        answer: "Absolutely. The Innova Crysta seats 6 to 7 passengers and is ideal for family vacations or group getaways."
    },
    {
        question: "Are the cabs sanitized before the trip?",
        answer: "Yes, all vehicles are thoroughly cleaned and sanitized before every journey to ensure your safety."
    },
    {
        question: "Do your drivers have experience with long-distance travel to Goa?",
        answer: "Yes, our drivers are highly experienced and familiar with Pune–Goa routes to ensure a safe and pleasant journey."
    },
    {
        question: "Is the Pune to Goa cab service available 24/7?",
        answer: "Yes, we operate round-the-clock so you can schedule your journey at any time convenient to you."
    },
    {
        question: "What payment modes are accepted for the booking?",
        answer: "We accept UPI, credit/debit cards, online banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Swapnil Kamat',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta from Pune to Goa. Clean car, smooth journey, and the driver was very polite and professional.”',
    },
    {
        name: 'Ms. Neha Sawant',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Excellent service! The Innova Crysta was perfect for our Goa trip. Spacious and extremely comfortable for long travel.”',
    },
];













































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const puneToGoaInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune to Goa Innova Crysta Cab Services Booking",
  "description": "Book chauffeur-driven Innova Crysta SUV cabs from Pune to Goa for one-way or round trip travel. Comfortable AC ride, ideal for family trips, private travel, or outstation holidays at affordable rates.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Outstation SUV Cab Service",
  "areaServed": {
    "@type": "City",
    "name": "Goa"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-goa-innova-crysta-cab"
  }
};






    return (
        <div>

<Helmet>
  <title>Pune to Goa Innova Crysta Cab | SUV Taxi Booking Online</title>
  <meta
    name="description"
    content="Hire Innova Crysta cab from Pune to Goa for one-way or round trip journeys. AC SUV with chauffeur for private, family or holiday travel. Online booking available now."
  />
  <meta
    name="keywords"
    content="Pune to Goa Innova Crysta Cab Booking, One Way Innova Crysta Pune to Goa, Round Trip Innova Crysta Pune Goa, AC Innova Crysta Taxi Pune Goa, Chauffeur Driven Innova Crysta Pune to Goa, Private Innova Crysta Taxi Pune to Goa, Online Booking Innova Crysta Cab Pune Goa, Family Innova Crysta Trip Pune Goa, Budget Innova Crysta Cab Pune Goa"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneToGoaInnovaSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/44.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetogoainnovacrystacabservicebooking;